export default __webpack_public_path__ + "static/reed-3--mobile-ae14b04ff0c20791ad9a8ead98665140.png";